<mat-spinner *ngIf="isLoading()"></mat-spinner>

<app-generic-filter-selector
            [availableFilters]="availableEducationalLevelsToFilters()"
            (filterClick)="onEducationalFilterSelected($event)"
            [extraContextInfoForAccessibility]="'accessibility.educationnal_level_filter' | translate"
></app-generic-filter-selector>
